import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { fetchLiquors } from './actions/fetchLiquors';
import reduxThunk from 'redux-thunk';
import reducers from './reducers';
import Products from './containers/Products';
import Product from './containers/Product';
import NavBar from './containers/NavBar';
import Landing from './containers/Landing';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { composeWithDevTools } from 'redux-devtools-extension';
import { MuiThemeProvider } from '@material-ui/core';
import SigninRegister from './containers/SigninRegister';
import Signup from './containers/Signup';
import AlertPopup from './components/AlertPopup';
import Cart from './containers/Cart';
import LoadingBar from 'react-redux-loading-bar';
import AuthRequired from './components/AuthRequired';
import Profile from './containers/Profile';

import theme from './css/theme';
import { watchAuthStatus } from './actions/userActions';

const store = createStore(
    reducers,
    composeWithDevTools(applyMiddleware(reduxThunk))
);

store.dispatch(fetchLiquors());
store.dispatch(watchAuthStatus());

ReactDOM.render(
    <MuiThemeProvider theme={theme}>
        <Provider store={store}>
            <LoadingBar
                style={{ backgroundColor: '#EDCE86', zIndex: '1200' }}
            />
            <Router>
                <Route exact path="/" component={Landing} />
                <Route path="/" component={AlertPopup} />
                <Route path="/liquors" component={NavBar} />
                <Route exact path="/liquors" component={Products} />
                <Route exact path="/liquors/:id" component={Product} />
                <Route exact path="/signup" component={Signup} />
                <Route
                    exact
                    path="/signin"
                    render={(props) => (
                        <SigninRegister {...props} mode="signin" />
                    )}
                />
                <Route
                    exact
                    path="/register"
                    render={(props) => (
                        <SigninRegister {...props} mode="register" />
                    )}
                />
                <AuthRequired exact path="/cart" component={Cart} />
                <AuthRequired exact path="/profile" component={Profile} />
            </Router>
        </Provider>
    </MuiThemeProvider>,
    document.getElementById('root')
);
